import { Link } from 'react-router-dom';
import PageHero from '../../components/PageHero';
import './StaticPage.css';

function ListYourBusinessPage() {
  return (
    <div className="static-page content-page">
      <PageHero
        title="List Your Business"
        subtitle="Reach thousands of couples planning their wedding"
      />
      <div className="content-container">
        <p>
          Join WeddingzVenue and showcase your venue or vendor services to couples across India. Get
          genuine enquiries, manage your profile, and grow your wedding business.
        </p>
        <ul>
          <li>Create a verified listing with photos, pricing, and details</li>
          <li>Receive and manage enquiries directly from couples</li>
          <li>Appear in search results by city and category</li>
          <li>Simple registration and profile setup</li>
        </ul>

        <div className="cta-box">
          <h3>Ready to get started?</h3>
          <p>Register as a business and complete your profile to go live.</p>
          <Link to="/register" className="btn-primary">
            Register your business
          </Link>
        </div>
      </div>
    </div>
  );
}

export default ListYourBusinessPage;
